import { render, staticRenderFns } from "./averagePriceCompare.vue?vue&type=template&id=1adb43b1&"
import script from "./averagePriceCompare.vue?vue&type=script&lang=js&"
export * from "./averagePriceCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports